import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HomesService extends BaseService {
  baseUrl = environment.apiUrl + 'Home';
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    super(http, authenticationSerives, environment.apiUrl + 'Home');
  }
}
